module.exports = __webpack_public_path__ + "stockLibrary/service_1-b9d0b250a2458d82bbecbaa5726aed59.png";